import { render, staticRenderFns } from "./ChildAccount.vue?vue&type=template&id=b581e2b0&"
import script from "./ChildAccount.vue?vue&type=script&lang=js&"
export * from "./ChildAccount.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports